(function () {
  'use strict';

  const DEFAULT_COLOR = 'White';
  const STYLE_TO_SHAPE = {
    'Straight': 'Straight',
    'Arch above': 'Arch Up',
    'Arch below': 'Arch Down'
  };

  function selectedOption(select) {
    return select && select.options ? select.options[select.selectedIndex] : null;
  }

  function selectedRadio(root, selector) {
    return root.querySelector(selector + ':checked');
  }

  function setValue(root, selector, value) {
    const field = root.querySelector(selector);
    if (!field) return;
    field.value = value == null ? '' : String(value);
  }

  function formatMoney(cents) {
    return '$' + (Math.max(0, Number(cents) || 0) / 100).toFixed(2);
  }

  function personalizedPrice(root, sizeOption, payload) {
    const basePrice = Number(sizeOption && sizeOption.dataset.priceCents);
    const textCount = [payload && payload.text1, payload && payload.text2].filter(Boolean).length;
    const exactCents = basePrice + textCount * 600;
    const node = root.querySelector('[data-srd-dc-price-variants]');
    let variants = [];
    try { variants = node ? JSON.parse(node.textContent || '[]') : []; } catch (error) { variants = []; }
    const variant = variants.find(function (item) {
      return item && item.available !== false && Number(item.price) === exactCents;
    });
    return Number.isInteger(basePrice) && basePrice > 0 && textCount > 0 && variant && variant.id
      ? { ready: true, cents: exactCents, variantId: String(variant.id) }
      : { ready: false, cents: 0, variantId: '' };
  }

  function approvedDcArtIds(root) {
    const node = root.querySelector('[data-srd-dc-art-catalog]');
    if (!node) return new Set();
    try {
      const catalog = JSON.parse(node.textContent || '');
      if (catalog.schemaVersion !== 'srd-dc-art-catalog-schema-v1' ||
          catalog.catalogVersion !== 'srd-dc-art-catalog-v1' ||
          !Array.isArray(catalog.records) ||
          Number(catalog.recordCount) !== catalog.records.length) return new Set();
      return new Set(catalog.records
        .filter(function (record) {
          return record &&
            record.productionReady6in === true &&
            Number(record.defaultNominalSize) === 6;
        })
        .map(function (record) { return String(record.designId || '').toLowerCase(); })
        .filter(Boolean));
    } catch (error) {
      return new Set();
    }
  }

  function styleToShape(value) {
    return STYLE_TO_SHAPE[value] || 'Straight';
  }

  function updateDesignerLink(root, colorName, sizeOption) {
    const link = root.querySelector('[data-srd-fixed-designer-link]');
    if (!link) return;
    const designId = String(root.dataset.srdFixedDesignId || '').trim();
    const ids = root._srdApprovedDcArtIds || new Set();
    if (!designId || !ids.has(designId.toLowerCase())) {
      link.hidden = true;
      link.removeAttribute('href');
      return;
    }
    const sizeNumber = Math.max(6, Number(String(sizeOption && sizeOption.value || '6').match(/\d+(?:\.\d+)?/)) || 6);
    const url = new URL('/pages/srd-designer', window.location.origin);
    url.searchParams.set('family', 'custom_die_cut_design');
    url.searchParams.set('dc_art', designId);
    url.searchParams.set('dc_size', String(sizeNumber));
    url.searchParams.set('dc_color', colorName || DEFAULT_COLOR);
    if (root.dataset.srdFixedSourceHandle) url.searchParams.set('source_handle', root.dataset.srdFixedSourceHandle);
    link.href = url.pathname + url.search;
    link.hidden = false;
  }

  function getPersonalizationPayload(root) {
    const textInput1 = root.querySelector('[data-srd-fixed-text-input-1]');
    const textInput2 = root.querySelector('[data-srd-fixed-text-input-2]');
    const fontInput = root.querySelector('[data-srd-fixed-font-1]');
    const styleInput = selectedRadio(root, '[data-srd-fixed-style-input]');
    const placementInput = selectedRadio(root, '[data-srd-fixed-placement-input]');
    const proofConfirm = root.querySelector('[data-srd-fixed-proof-confirm]');

    const text1 = String(textInput1 && textInput1.value || '').trim();
    const text2 = String(textInput2 && textInput2.value || '').trim();
    const font1 = String(fontInput && fontInput.value || 'Berlin Sans').trim() || 'Berlin Sans';
    const styleLabel = String(styleInput && styleInput.value || 'Straight').trim() || 'Straight';
    const placement = String(placementInput && placementInput.value || 'Above design').trim() || 'Above design';
    const confirmed = Boolean(proofConfirm && proofConfirm.checked);
    const hasText1 = text1.length > 0;
    const hasText2 = text2.length > 0;

    return {
      text1: text1,
      text2: text2,
      text2Enabled: hasText2,
      font1: font1,
      styleLabel: styleLabel,
      styleShape: styleToShape(styleLabel),
      placement: placement,
      proofRef: '',
      proofConfirmed: confirmed,
      hasText1: hasText1,
      complete: hasText1 && confirmed
    };
  }

  function syncFontPreviewCards(root, payload) {
    const select = root.querySelector('[data-srd-fixed-font-1]');
    const selectedValue = String(select && select.value || payload && payload.font1 || 'Berlin Sans');
    const sample = String(payload && payload.text1 || '').trim() || 'YOUR TEXT';
    root.querySelectorAll('[data-srd-fixed-font-choice]').forEach(function (choice) {
      const selected = choice.value === selectedValue;
      choice.checked = selected;
      choice.setAttribute('aria-checked', selected ? 'true' : 'false');
      const card = choice.closest('[data-font-value]');
      if (card) card.classList.toggle('is-selected', selected);
      const label = choice.getAttribute('aria-label') || choice.value;
      choice.setAttribute('aria-label', label.replace(/\. Preview:.*$/, '') + '. Preview: ' + sample);
    });
    root.querySelectorAll('[data-srd-fixed-font-sample]').forEach(function (preview) {
      preview.textContent = sample;
    });
  }

  function updatePersonalizationFields(root, payload, unitPriceCents) {
    if (!payload) return;
    setValue(root, '[data-srd-fixed-text-1]', payload.text1);
    setValue(root, '[data-srd-fixed-font-name-1]', payload.font1);
    setValue(root, '[data-srd-fixed-style-1]', payload.styleShape);
    setValue(root, '[data-srd-fixed-arc-1]', payload.styleLabel === 'Straight' ? '' : '0.75');
    setValue(root, '[data-srd-fixed-text-2]', payload.text2);
    setValue(root, '[data-srd-fixed-font-name-2]', payload.text2Enabled ? payload.font1 : '');
    setValue(root, '[data-srd-fixed-style-2]', payload.text2Enabled ? payload.styleShape : '');
    setValue(root, '[data-srd-fixed-placement]', payload.placement);
    setValue(root, '[data-srd-fixed-proof-confirmed]', payload.proofConfirmed ? 'Yes' : '');
    if (unitPriceCents != null) setValue(root, '[data-srd-fixed-exact-price]', formatMoney(unitPriceCents));
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (!payload.complete) {
      root.dataset.srdDcContractReady = 'false';
      root.querySelectorAll('[data-srd-dc-contract]').forEach(function (field) { field.remove(); });
    } else if (form && window.SRDDcPersonalizeContract && typeof window.SRDDcPersonalizeContract.install === 'function') {
      try {
        window.SRDDcPersonalizeContract.install(root, form);
        root.dataset.srdDcContractReady = 'true';
        delete root.dataset.srdDcContractError;
      } catch (error) {
        root.dataset.srdDcContractReady = 'false';
        root.dataset.srdDcContractError = error.message || 'The trusted DC personalization contract is incomplete.';
        root.querySelectorAll('[data-srd-dc-contract]').forEach(function (field) { field.remove(); });
        setValidationMessage(root, root.dataset.srdDcContractError);
      }
    }
  }

  function setValidationMessage(root, message) {
    const copy = root.querySelector('[data-srd-fixed-validation-copy]');
    if (!copy) return;
    copy.textContent = message || '';
    copy.classList.toggle('is-visible', Boolean(message));
  }

  function renderPersonalizeValidation(root, payload, availabilityOk) {
    const trigger = root.querySelector('[data-srd-fixed-personalize-open]');
    const submit = root.querySelector('[data-srd-fixed-submit]');
    const label = submit ? submit.querySelector('span') : null;
    const pricePreview = root.querySelector('[data-srd-fixed-personalize-pricing]');
    const formStatus = root.querySelector('.product-form__error-message-wrapper');
    const formMessage = formStatus && formStatus.querySelector('.product-form__error-message');

    const hasPayload = payload && payload.complete && root.dataset.srdDcContractReady === 'true';
    if (availabilityOk && submit) {
      if (!hasPayload) {
        submit.disabled = true;
        if (label) label.textContent = 'Complete personalization';
        if (trigger) trigger.textContent = 'PERSONALIZE THIS DESIGN';
        setValidationMessage(root, 'Please provide at least one text line, confirm the proof, and add a proof reference.');
      } else {
        submit.disabled = false;
        if (label) label.textContent = 'Add to cart';
        trigger && (trigger.textContent = 'Edit personalization');
        setValidationMessage(root, '');
      }
    } else if (submit) {
      submit.disabled = true;
      if (label) {
        if (!availabilityOk) label.textContent = 'Sold out';
        else label.textContent = 'Unavailable';
      }
      setValidationMessage(root, 'The selected option is unavailable. Please change size or try again.');
    }

    if (formMessage) formMessage.textContent = '';
    if (formStatus) formStatus.hidden = true;
    if (pricePreview) {
      const quantity = Math.max(1, Math.floor(Number((root.querySelector('input[name="quantity"]') && root.querySelector('input[name="quantity"]').value) || 1)));
      const unitText = pricePreview.dataset.unitPrice || pricePreview.dataset.unitPrice === '0' ? Number(pricePreview.dataset.unitPrice) : null;
      if (unitText != null && !Number.isNaN(unitText)) {
        pricePreview.textContent = formatMoney(unitText * quantity);
      }
    }
  }

  function setPanelOpen(root, isOpen) {
    const panel = root.querySelector('[data-srd-fixed-personalize-panel]');
    if (!panel) return;
    panel.classList.toggle('is-open', isOpen);
    panel.hidden = !isOpen;
  }

  function setValueFromSelections(root, quantity) {
    const quantityInput = root.querySelector('input[name="quantity"]');
    if (personalizationPrice && !Number.isNaN(Number(quantity))) {
      const unitPriceText = personalizationPrice.dataset.unitPrice || '0';
      const unitPrice = Number(unitPriceText);
      personalizationPrice.textContent = formatMoney(unitPrice * quantity);
      personalizationPrice.dataset.unitPrice = String(unitPrice);
    }
    if (quantityInput) quantityInput.value = String(quantity);
  }

  function updateOrderPresentation(root) {
    const sizeOption = selectedOption(root.querySelector('[data-srd-fixed-size]'));
    const quantityInput = root.querySelector('input[name="quantity"]');
    const quantity = Math.max(1, Math.floor(Number(quantityInput && quantityInput.value) || 1));
    const unitPriceCents = Math.max(0, Number(sizeOption && sizeOption.dataset.priceCents) || 0);
    const totalCents = unitPriceCents * quantity;
    const liveTotal = root.querySelector('[data-srd-fixed-live-total]');
    const shippingProgress = root.querySelector('[data-srd-fixed-free-shipping-progress]');
    const personalizationPrice = root.querySelector('[data-srd-fixed-personalize-pricing]');

    if (liveTotal) liveTotal.textContent = formatMoney(totalCents);
    if (shippingProgress) {
      const progress = Math.min(100, (totalCents / 3500) * 100);
      shippingProgress.style.setProperty('--srd-progress', progress.toFixed(2) + '%');
    }
  }

  function syncValidationHint(root, payload, available) {
    const hint = root.querySelector('[data-srd-fixed-validation-copy]');
    if (!hint) return;
    if (!available) {
      hint.textContent = 'The selected size is unavailable. Please choose another size.';
      return;
    }
    if (!payload || !payload.text1) {
      hint.textContent = 'Add at least one line of text to proceed.';
      return;
    }
    if (!payload.proofConfirmed) {
      hint.textContent = 'Check the proof confirmation box to continue.';
      return;
    }
    hint.textContent = '';
  }

  function setFormError(root, message) {
    const formStatus = root.querySelector('.product-form__error-message-wrapper');
    const formMessage = formStatus && formStatus.querySelector('.product-form__error-message');
    if (!formStatus || !formMessage) return;
    formMessage.textContent = message || '';
    formStatus.hidden = !message;
  }

  function getPanelOpenButton(root) {
    return root.querySelector('[data-srd-fixed-personalize-open]');
  }

  function update(root) {
    const color = root.querySelector('[data-srd-fixed-color]');
    const size = root.querySelector('[data-srd-fixed-size]');
    if (!color || !size) return;

    let colorOption = selectedOption(color);
    if (!colorOption || !colorOption.dataset.colorValue) {
      color.value = DEFAULT_COLOR;
      colorOption = selectedOption(color);
    }

    const sizeOption = selectedOption(size);
    const colorName = colorOption ? colorOption.value : DEFAULT_COLOR;
    const colorValue = colorOption ? colorOption.dataset.colorValue : '#ffffff';
    const variantId = sizeOption ? sizeOption.dataset.variantId : '';
    const available = Boolean(sizeOption && sizeOption.dataset.available === 'true');
    const width = sizeOption ? sizeOption.dataset.width : '';
    const height = sizeOption ? sizeOption.dataset.height : '';
    const unitPriceCents = sizeOption ? Number(sizeOption.dataset.priceCents) : 0;
    const unitMoney = formatMoney(unitPriceCents);

    root.style.setProperty('--srd-selected-color', colorValue);
    root.classList.toggle('srd-fixed-die-cut--white-vinyl', colorName === DEFAULT_COLOR);
    setValue(root, '[data-srd-fixed-variant-id]', variantId);
    setValue(root, '[data-srd-fixed-width]', width);
    setValue(root, '[data-srd-fixed-height]', height);
    setValue(root, '[data-srd-fixed-exact-price]', unitMoney);

    const price = root.querySelector('[data-srd-fixed-price]');
    if (price && sizeOption && sizeOption.dataset.price) price.textContent = sizeOption.dataset.price;
    const proofPrice = root.querySelector('[data-srd-fixed-personalize-pricing]');
    if (proofPrice) proofPrice.textContent = unitMoney;

    const proofColor = root.querySelector('[data-srd-fixed-proof-color]');
    if (proofColor) proofColor.textContent = colorName + ' vinyl proof';
    const proofArt = root.querySelector('[data-srd-fixed-proof-art]');
    if (proofArt) proofArt.setAttribute('aria-label', 'Approved fixed artwork shown in ' + colorName + ' vinyl');

    root.querySelectorAll('[data-srd-fixed-color-choice]').forEach(function (choice) {
      const active = choice.dataset.srdFixedColorChoice === colorName;
      choice.classList.toggle('is-selected', active);
      choice.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    updateDesignerLink(root, colorName, sizeOption);
    updateOrderPresentation(root);

    const payload = getPersonalizationPayload(root);
    const exactPrice = personalizedPrice(root, sizeOption, payload);
    const panelSize = root.querySelector('[data-srd-fixed-panel-size]');
    const panelColor = root.querySelector('[data-srd-fixed-panel-color]');
    const panelQuantity = root.querySelector('[data-srd-fixed-panel-quantity]');
    if (panelSize && panelSize.value !== size.value) panelSize.value = size.value;
    if (panelColor && panelColor.value !== color.value) panelColor.value = color.value;
    if (panelQuantity && panelQuantity.value !== String(Math.max(1, Number(root.querySelector('input[name="quantity"]') && root.querySelector('input[name="quantity"]').value) || 1))) {
      panelQuantity.value = String(Math.max(1, Number(root.querySelector('input[name="quantity"]') && root.querySelector('input[name="quantity"]').value) || 1));
    }
    const proofText = root.querySelector('[data-srd-fixed-simple-proof-text]');
    const proofCaption = root.querySelector('[data-srd-fixed-simple-proof-caption]');
    if (proofText) proofText.textContent = [payload.text1, payload.text2].filter(Boolean).join(' / ') || 'YOUR TEXT';
    if (proofCaption) {
      const sizeMatch = String(sizeOption && sizeOption.value || '6').match(/\d+(?:\.\d+)?/);
      proofCaption.textContent = String(sizeMatch ? Number(sizeMatch[0]) : 6) + ' in · ' + colorName + ' · ' + payload.placement;
    }
    syncFontPreviewCards(root, payload);
    root.dataset.srdDcExactPriceReady = exactPrice.ready ? 'true' : 'false';
    if (proofPrice) {
      const quantityValue = Math.max(1, Number(root.querySelector('input[name="quantity"]') && root.querySelector('input[name="quantity"]').value) || 1);
      proofPrice.textContent = exactPrice.ready ? formatMoney(exactPrice.cents * quantityValue) : 'Unavailable';
      proofPrice.dataset.unitPrice = exactPrice.ready ? String(exactPrice.cents) : '';
    }
    updatePersonalizationFields(root, payload, exactPrice.ready ? exactPrice.cents : null);
    const trigger = getPanelOpenButton(root);
    if (trigger) trigger.textContent = payload && payload.complete ? 'Edit personalization' : 'PERSONALIZE THIS DESIGN';
    renderPersonalizationState(root, sizeOption, available && exactPrice.ready, payload, exactPrice.cents);

    const quantity = root.querySelector('input[name="quantity"]');
    if (quantity) {
      quantity.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  function renderPersonalizationState(root, sizeOption, available, payload, unitPriceCents) {
    const submit = root.querySelector('[data-srd-fixed-submit]');
    const hasPersonalization = payload && payload.complete && root.dataset.srdDcContractReady === 'true';
    if (submit) {
      if (root.dataset.configurationValid !== 'true') {
        submit.disabled = true;
        const label = submit.querySelector('span');
        if (label) label.textContent = 'Unavailable';
        setValidationMessage(root, 'This design is temporarily unavailable.');
      } else if (!sizeOption || !sizeOption.dataset.variantId || !available) {
        submit.disabled = true;
        const label = submit.querySelector('span');
        if (label) label.textContent = 'Sold out';
        setValidationMessage(root, 'The selected size is unavailable.');
      } else if (!hasPersonalization) {
        submit.disabled = true;
        const label = submit.querySelector('span');
        if (label) label.textContent = 'Complete personalization';
        if (payload && payload.complete && root.dataset.srdDcContractError) {
          setValidationMessage(root, root.dataset.srdDcContractError);
        } else {
          syncValidationHint(root, payload || {}, available);
        }
      } else {
        submit.disabled = false;
        const label = submit.querySelector('span');
        if (label) label.textContent = 'Add to cart';
        syncValidationHint(root, payload || {}, available);
      }
    }
    const openButton = getPanelOpenButton(root);
    if (openButton && root.dataset.configurationValid === 'true') {
      openButton.disabled = false;
    } else if (openButton) {
      openButton.disabled = true;
    }
  }

  function selectWhite(color) {
    if (!color) return;
    const white = Array.from(color.options).find(function (option) {
      return option.value === DEFAULT_COLOR;
    });
    color.value = white ? DEFAULT_COLOR : '';
  }

  function bindPanel(root) {
    const openButton = getPanelOpenButton(root);
    const panel = root.querySelector('[data-srd-fixed-personalize-panel]');
    const closeButtons = root.querySelectorAll('[data-srd-fixed-personalize-close]');
    if (!openButton || !panel) return;

    openButton.addEventListener('click', function () {
      if (openButton.disabled) return;
      setPanelOpen(root, true);
      const firstTextInput = root.querySelector('[data-srd-fixed-text-input-1]');
      if (firstTextInput) firstTextInput.focus({ preventScroll: true });
    });

    closeButtons.forEach(function (closeButton) {
      closeButton.addEventListener('click', function () {
        setPanelOpen(root, false);
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.querySelector('[data-srd-fixed-personalize-panel]:not([hidden])')) {
        event.stopPropagation();
        setPanelOpen(root, false);
      }
    });
  }

  function bindInputs(root) {
    const panel = root.querySelector('[data-srd-fixed-personalize-panel]');
    if (!panel) return;
    const monitoredSelectors = [
      '[data-srd-fixed-text-input-1]',
      '[data-srd-fixed-text-input-2]',
      '[data-srd-fixed-font-1]',
      '[data-srd-fixed-proof-confirm]',
      '[name="srd-personalize-style-' + root.dataset.section + '"]',
      '[name="srd-personalize-placement-' + root.dataset.section + '"]'
    ];
    const fallbackName = root.dataset.section;

    const selector = '[name="srd-personalize-style-' + fallbackName + '"]';
    panel.querySelectorAll(selector + ', [data-srd-fixed-text-input-1], [data-srd-fixed-text-input-2], [data-srd-fixed-font-1], [data-srd-fixed-proof-confirm], [name="srd-personalize-placement-' + fallbackName + '"]').forEach(function (control) {
      control.addEventListener('input', function () {
        update(root);
      });
      control.addEventListener('change', function () {
        update(root);
      });
    });
    const fontSelect = panel.querySelector('[data-srd-fixed-font-1]');
    panel.querySelectorAll('[data-srd-fixed-font-choice]').forEach(function (choice) {
      choice.addEventListener('change', function () {
        if (!choice.checked || !fontSelect) return;
        fontSelect.value = choice.value;
        fontSelect.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    const panelSize = panel.querySelector('[data-srd-fixed-panel-size]');
    const panelColor = panel.querySelector('[data-srd-fixed-panel-color]');
    const panelQuantity = panel.querySelector('[data-srd-fixed-panel-quantity]');
    if (panelSize) panelSize.addEventListener('change', function () {
      const main = root.querySelector('[data-srd-fixed-size]');
      if (main) main.value = panelSize.value;
      update(root);
    });
    if (panelColor) panelColor.addEventListener('change', function () {
      const main = root.querySelector('[data-srd-fixed-color]');
      if (main) main.value = panelColor.value;
      update(root);
    });
    if (panelQuantity) panelQuantity.addEventListener('input', function () {
      const main = root.querySelector('input[name="quantity"]');
      const value = Math.max(1, Math.floor(Number(panelQuantity.value) || 1));
      if (main) main.value = String(value);
      update(root);
    });
  }

  function wireSubmitProtection(root) {
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    if (form.dataset.srdFixedPersonalizationGuard === 'true') return;
    form.dataset.srdFixedPersonalizationGuard = 'true';

    form.addEventListener('submit', function (event) {
      const payload = getPersonalizationPayload(root);
      const variant = root.querySelector('[data-srd-fixed-size]');
      const sizeOption = variant ? selectedOption(variant) : null;
      const available = Boolean(sizeOption && sizeOption.dataset.available === 'true' && sizeOption.dataset.variantId);
      const complete = payload && payload.complete;
      const valid = root.dataset.configurationValid === 'true' && available && complete;

      if (!valid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        syncValidationHint(root, payload || {}, available);
        setFormError(root, 'Complete personalization before adding this item to cart.');
        const panel = root.querySelector('[data-srd-fixed-personalize-panel]');
        if (panel && panel.hidden) {
          setPanelOpen(root, true);
        }
      } else {
        setFormError(root, '');
      }
    }, true);
  }

  function initializeDefaultValues(root) {
    const color = root.querySelector('[data-srd-fixed-color]');
    const text1 = root.querySelector('[data-srd-fixed-text-input-1]');
    const font = root.querySelector('[data-srd-fixed-font-1]');
    if (text1) text1.value = '';
    if (font) font.value = font.options ? font.options[0].value : 'Berlin Sans';
    const confirm = root.querySelector('[data-srd-fixed-proof-confirm]');
    if (confirm) confirm.checked = false;
    selectWhite(color);
  }

  function init(root) {
    if (root.dataset.srdFixedInitialized === 'true') {
      selectWhite(root.querySelector('[data-srd-fixed-color]'));
      update(root);
      return;
    }

    root.dataset.srdFixedInitialized = 'true';
    root._srdApprovedDcArtIds = approvedDcArtIds(root);

    initializeDefaultValues(root);

    root.querySelectorAll('[data-srd-fixed-color], [data-srd-fixed-size]').forEach(function (control) {
      control.addEventListener('change', function () { update(root); });
    });

    root.querySelectorAll('[data-srd-fixed-color-choice]').forEach(function (choice) {
      choice.addEventListener('click', function () {
        const color = root.querySelector('[data-srd-fixed-color]');
        if (!color || choice.disabled) return;
        color.value = choice.dataset.srdFixedColorChoice;
        update(root);
      });
    });

    root.querySelectorAll('[data-srd-fixed-thumbnail]').forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        const image = root.querySelector('[data-srd-fixed-proof-image]');
        if (!image || !thumbnail.dataset.imageSrc) return;
        image.src = thumbnail.dataset.imageSrc;
        root.querySelectorAll('[data-srd-fixed-thumbnail]').forEach(function (item) {
          const active = item === thumbnail;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
      });
    });

    bindPanel(root);
    bindInputs(root);
    wireSubmitProtection(root);
    update(root);
  }

  function initAll() {
    document.querySelectorAll('[data-srd-fixed-die-cut]').forEach(init);
  }

  document.addEventListener('input', function (event) {
    if (!event.target.matches('input[name="quantity"]')) return;
    const root = event.target.closest('[data-srd-fixed-die-cut]');
    if (root) updateOrderPresentation(root);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('input[name="quantity"]')) return;
    const root = event.target.closest('[data-srd-fixed-die-cut]');
    if (root) updateOrderPresentation(root);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
  else initAll();

  document.addEventListener('shopify:section:load', function (event) {
    const root = event.target.querySelector('[data-srd-fixed-die-cut]');
    if (root) init(root);
  });

  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-srd-fixed-die-cut]').forEach(function (root) {
      selectWhite(root.querySelector('[data-srd-fixed-color]'));
      initializeDefaultValues(root);
      update(root);
    });
  });

  window.SRDFixedDieCut = Object.freeze({ DEFAULT_COLOR: DEFAULT_COLOR, update: update, styleToShape: styleToShape });
}());

(function () {
  'use strict';

  const DC_CONTRACT_VERSION = 'srd-dc-art-plus-text-production-v1';
  const CATALOG_SCHEMA_VERSION = 'srd-dc-art-catalog-schema-v1';
  const CATALOG_VERSION = 'srd-dc-art-catalog-v1';

  function propertyControl(root, labels) {
    const names = labels.map(function (label) { return 'properties[' + label + ']'; });
    return Array.from(root.querySelectorAll('[name]')).find(function (control) {
      return names.includes(control.name) && (control.type !== 'radio' || control.checked);
    }) || null;
  }

  function propertyValue(root, labels) {
    const control = propertyControl(root, labels);
    if (!control) return '';
    if (control.type === 'checkbox') return control.checked ? String(control.value || 'Yes') : '';
    return String(control.value || '').trim();
  }

  function hiddenProperty(form, name, value) {
    let field = Array.from(form.querySelectorAll('input[type="hidden"]')).find(function (input) {
      return input.name === 'properties[' + name + ']';
    });
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'properties[' + name + ']';
      field.dataset.srdDcContract = 'true';
      form.appendChild(field);
    }
    field.value = String(value == null ? '' : value);
  }

  function parseCatalog(root) {
    const node = root.querySelector('[data-srd-dc-art-catalog]');
    if (!node) throw new Error('The trusted DC Art catalog is unavailable.');
    const catalog = JSON.parse(node.textContent || '');
    if (catalog.schemaVersion !== CATALOG_SCHEMA_VERSION
        || catalog.catalogVersion !== CATALOG_VERSION
        || !Array.isArray(catalog.records)
        || Number(catalog.recordCount) !== catalog.records.length) {
      throw new Error('The trusted DC Art catalog contract is invalid.');
    }
    const designId = String(root.dataset.srdFixedDesignId || '').trim();
    const record = catalog.records.find(function (item) {
      return item && String(item.designId || '').toLowerCase() === designId.toLowerCase();
    });
    if (!record || record.productionReady6in !== true) {
      throw new Error('This artwork is not approved for physical DC personalization.');
    }
    return { catalog: catalog, record: record, designId: designId };
  }

  function numberFrom(value) {
    const match = String(value || '').match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : NaN;
  }

  function round(value) {
    return Math.round(Number(value) * 1000) / 1000;
  }

  function colorKey(value) {
    return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '');
  }

  function fontKey(value) {
    const label = String(value || '').trim();
    const approved = {
      'Berlin Sans': 'berlin-sans-regular',
      'Anton': 'anton',
      'Bebas Neue': 'bebas-neue',
      'Stencil': 'stencil',
      'Arial Rounded Bold': 'arial-rounded-bold'
    };
    return approved[label] || '';
  }

  function numberFromSize(value) {
    const match = String(value || '').match(/\d+(?:\.\d+)?/);
    return match ? Number(match[0]) : NaN;
  }

  function exactPriceVariant(root, exactCents) {
    const node = root.querySelector('[data-srd-dc-price-variants]');
    if (!node) throw new Error('The approved Custom Die price map is unavailable.');
    let variants = [];
    try { variants = JSON.parse(node.textContent || '[]'); } catch (error) { variants = []; }
    const match = variants.find(function (variant) {
      return variant && variant.available !== false && Number(variant.price) === Number(exactCents);
    });
    if (!match || !match.id) throw new Error('No approved Custom Die variant matches the exact personalized price.');
    return { id: String(match.id), price: Number(match.price) };
  }

  function shapeKey(value) {
    const normalized = String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '_');
    if (normalized.includes('down')) return 'arch_down';
    if (normalized.includes('up') || normalized.includes('arch')) return 'arch_up';
    return 'straight';
  }

  function transactionToken() {
    const identity = window.crypto && typeof window.crypto.randomUUID === 'function'
      ? window.crypto.randomUUID()
      : Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
    return 'srd-dc-personalize-' + identity.replace(/[^A-Za-z0-9_-]/g, '');
  }

  function layoutContract(artWidth, artHeight, textRows, placement) {
    const gap = 0.25;
    const rowGap = 0.12;
    const textHeight = 1.25;
    const widestText = Math.max.apply(null, textRows.map(function (row) {
      return Math.max(1.25, Math.min(8.5, row.text.replace(/\s/g, '').length * 0.75));
    }));
    const textBlockHeight = textRows.length * textHeight + Math.max(0, textRows.length - 1) * rowGap;
    const normalizedPlacement = String(placement || '').toLowerCase();
    const isOverlay = normalizedPlacement.includes('on design');
    const isSide = normalizedPlacement.includes('left') || normalizedPlacement.includes('right');
    const before = normalizedPlacement.includes('top') || normalizedPlacement.includes('above') || normalizedPlacement.includes('left');
    const canvasWidth = round(isOverlay ? artWidth : (isSide ? artWidth + gap + widestText : Math.max(artWidth, widestText)));
    const canvasHeight = round(isOverlay ? artHeight : (isSide ? Math.max(artHeight, textBlockHeight) : artHeight + gap + textBlockHeight));
    if (canvasWidth > 12.001 || canvasHeight > 12.001) {
      throw new Error('This artwork-plus-text placement exceeds the certified 12-inch production envelope.');
    }
    const artX = isSide ? (before ? widestText + gap + artWidth / 2 : artWidth / 2) : canvasWidth / 2;
    const artY = isOverlay ? canvasHeight / 2 : (isSide ? canvasHeight / 2 : (before ? textBlockHeight + gap + artHeight / 2 : artHeight / 2));
    const textCenterX = isSide ? (before ? widestText / 2 : artWidth + gap + widestText / 2) : canvasWidth / 2;
    const textStartY = isOverlay ? (canvasHeight - textBlockHeight) / 2 + textHeight / 2 : (isSide ? (canvasHeight - textBlockHeight) / 2 + textHeight / 2 : (before ? textHeight / 2 : artHeight + gap + textHeight / 2));
    return {
      canvas: { width: canvasWidth, height: canvasHeight, unit: 'in' },
      art: { x: round(artX), y: round(artY), width: round(artWidth), height: round(artHeight), rotation: 0 },
      text: textRows.map(function (row, index) {
        return Object.assign({}, row, {
          x: round(textCenterX),
          y: round(textStartY + index * (textHeight + rowGap)),
          width: round(Math.max(1.25, Math.min(widestText, row.text.replace(/\s/g, '').length * 0.75))),
          height: textHeight,
          rotation: 0
        });
      })
    };
  }

  function percent(value, total) {
    return round(Number(value) / Number(total) * 100);
  }

  function buildContract(root) {
    const trusted = parseCatalog(root);
    const sizeOption = root.querySelector('[data-srd-fixed-size] option:checked');
    const colorOption = root.querySelector('[data-srd-fixed-color] option:checked');
    const basePriceCents = Number(sizeOption && sizeOption.dataset.priceCents);
    const artSize = numberFrom(sizeOption && sizeOption.value);
    const exactDimensions = trusted.record.exactDimensions && trusted.record.exactDimensions[String(artSize)];
    const artWidth = Number(exactDimensions && exactDimensions.width || sizeOption && sizeOption.dataset.width);
    const artHeight = Number(exactDimensions && exactDimensions.height || sizeOption && sizeOption.dataset.height);
    const vinylColor = String(colorOption && colorOption.value || '').trim();
    const approvedColors = Array.isArray(trusted.record.approvedVinylColors) ? trusted.record.approvedVinylColors : [];
    const quantityControl = root.querySelector('input[name="quantity"]');
    const quantity = Math.floor(Number(quantityControl && quantityControl.value));
    if (!Number.isInteger(basePriceCents) || basePriceCents < 1 || !Number.isFinite(artSize)
        || !Number.isFinite(artWidth) || !Number.isFinite(artHeight) || !Number.isInteger(quantity) || quantity < 1) {
      throw new Error('The exact Shopify price-bearing variant is unresolved.');
    }
    if (![6, 8, 10, 12].includes(artSize) || !exactDimensions) {
      throw new Error('The selected artwork size is not certified.');
    }
    if (!approvedColors.includes(vinylColor)) {
      throw new Error('The selected vinyl color is not approved for this artwork.');
    }

    const textRows = [1, 2, 3].map(function (index) {
      const text = propertyValue(root, ['Text ' + index]);
      if (!text) return null;
      if (text.replace(/\s/g, '').length > 12) throw new Error('Text ' + index + ' exceeds 12 production characters.');
      const font = propertyValue(root, ['Font ' + index]) || propertyValue(root, ['Font 1']);
      const style = propertyValue(root, ['Text ' + index + ' Shape', 'Style ' + index])
        || propertyValue(root, ['Text 1 Shape', 'Style 1']) || 'Straight';
      if (!font) throw new Error('Choose a certified font for Text ' + index + '.');
      return { instanceId: 'dc-text-' + index, text: text, fontKey: fontKey(font), shape: shapeKey(style), font: font, style: style };
    }).filter(Boolean);
    if (!textRows.length) throw new Error('Add at least one valid text object.');
    if (textRows.some(function (row) { return !row.fontKey; })) throw new Error('Choose an approved production font.');
    const placement = propertyValue(root, ['Placement', 'Preset Placement']);
    if (!placement) throw new Error('Choose a preset text placement.');
    const proofConfirmed = propertyValue(root, ['Proof Confirmed', 'Proof confirmation']);
    if (!proofConfirmed || /^(false|no|0)$/i.test(proofConfirmed)) throw new Error('Confirm the personalization proof before adding to cart.');

    const additionalTextUnitCents = 600;
    const additionalTextSurchargeCents = additionalTextUnitCents * textRows.length;
    const unitPriceCents = basePriceCents + additionalTextSurchargeCents;
    const priceVariant = exactPriceVariant(root, unitPriceCents);
    const variantId = priceVariant.id;
    const layout = layoutContract(artWidth, artHeight, textRows, placement);
    const physicalCanvas = { version: 1, unit: 'in', width: 12, height: 12, trustedDcArtRestore: true };
    const offsetX = round((physicalCanvas.width - layout.canvas.width) / 2);
    const offsetY = round((physicalCanvas.height - layout.canvas.height) / 2);
    const positionedArt = Object.assign({}, layout.art, { x: round(layout.art.x + offsetX), y: round(layout.art.y + offsetY) });
    const positionedText = layout.text.map(function (row) {
      return Object.assign({}, row, { x: round(row.x + offsetX), y: round(row.y + offsetY) });
    });
    const selectedColorKey = colorKey(vinylColor);
    const canvasObjects = {
      artwork: {
        x: percent(positionedArt.x, physicalCanvas.width),
        y: percent(positionedArt.y, physicalCanvas.height),
        scale: 1,
        width: percent(positionedArt.width, physicalCanvas.width),
        height: percent(positionedArt.height, physicalCanvas.height),
        rotation: 0
      },
      textObjects: positionedText.map(function (row) {
        return {
          id: row.instanceId,
          text: row.text,
          font: row.font,
          fontKey: row.fontKey,
          fontColor: vinylColor,
          fontColorKey: selectedColorKey,
          textShape: row.shape,
          arcAmount: row.shape === 'straight' ? 0 : 35,
          x: percent(row.x, physicalCanvas.width),
          y: percent(row.y, physicalCanvas.height),
          scale: 1,
          horizontalScale: 1,
          width: percent(row.width, physicalCanvas.width),
          height: percent(row.height, physicalCanvas.height),
          maxFontSize: 260,
          rotation: 0,
          outlineEnabled: false,
          outlineColorKey: 'white',
          outlineThicknessKey: 'medium'
        };
      }),
      shape: null,
      header: null,
      symbolObjects: [],
      layerOrder: ['artwork'].concat(positionedText.map(function (row) { return 'text:' + row.instanceId; }))
    };
    const productionText = positionedText.map(function (row) {
      return {
        instanceId: row.instanceId,
        text: row.text,
        fontKey: row.fontKey,
        shape: row.shape,
        x: row.x,
        y: row.y,
        width: row.width,
        height: row.height,
        rotation: 0,
        color: vinylColor
      };
    });
    const finishedEnvelope = { width: layout.canvas.width, height: layout.canvas.height };
    const dcContract = {
      contractVersion: DC_CONTRACT_VERSION,
      catalogVersion: trusted.catalog.catalogVersion,
      designId: trusted.designId,
      title: String(trusted.record.title || ''),
      artSizeInches: artSize,
      priceTierInches: artSize,
      vinylColor: vinylColor,
      art: positionedArt,
      textObjects: productionText,
      finishedEnvelopeInches: finishedEnvelope,
      presetPlacement: placement,
      pricing: {
        model: 'DC Art Library exact-unit-price variants v1',
        textObjectCount: textRows.length,
        includedTextObjectCount: 0,
        additionalTextObjectCount: textRows.length,
        additionalTextUnitCents: additionalTextUnitCents,
        additionalTextSurchargeCents: additionalTextSurchargeCents,
        unitPriceCents: unitPriceCents,
        finishedQuantity: quantity,
        finishedPriceCents: unitPriceCents * quantity
      }
    };
    const finishedPriceCents = unitPriceCents * quantity;
    const token = transactionToken();
    const referenceId = 'SRD-DCAPT-' + trusted.designId + '-' + artSize + '-' + token;
    const dieObjects = productionText.map(function (row) {
      return {
        id: row.instanceId,
        type: 'text',
        text: row.text,
        fontKey: row.fontKey,
        textShape: row.shape,
        vinylColor: { key: selectedColorKey, name: vinylColor },
        transformedPaintedBoundsIn: {
          left: round(row.x - row.width / 2), top: round(row.y - row.height / 2),
          right: round(row.x + row.width / 2), bottom: round(row.y + row.height / 2),
          width: row.width, height: row.height
        }
      };
    });
    const dieContract = {
      contractVersion: 'srd-dcp-die-production-v1',
      physicalCanvas: physicalCanvas,
      objects: dieObjects,
      eligibility: { status: 'ready', failures: [], warnings: [] },
      pricing: {
        model: 'DC Art Library exact-unit-price variants v1', textObjectCount: productionText.length,
        includedTextObjectCount: 0, additionalTextObjectCount: productionText.length,
        additionalTextUnitCents: additionalTextUnitCents, additionalTextSurchargeCents: additionalTextSurchargeCents,
        unitPriceCents: unitPriceCents, finishedQuantity: quantity, finishedPriceCents: finishedPriceCents
      }
    };
    return {
      token: token,
      referenceId: referenceId,
      variantId: variantId,
      unitPriceCents: unitPriceCents,
      finishedPriceCents: finishedPriceCents,
      quantity: quantity,
      artSize: artSize,
      complexityTier: String(trusted.record.complexityTier || ''),
      vinylColor: vinylColor,
      placement: placement,
      textRows: textRows,
      canvasObjects: canvasObjects,
      physicalCanvas: physicalCanvas,
      dieContract: dieContract,
      dcContract: dcContract
    };
  }

  function installContract(root, form) {
    const contract = buildContract(root);
    const variantField = form.querySelector('[name="id"]');
    if (!variantField) throw new Error('The Shopify variant field is unavailable.');
    variantField.value = contract.variantId;
    const firstText = contract.textRows[0];
    const properties = {
      'Product Family': 'Custom Die-Cut Vinyl Lettering',
      'DC Art Library Design': contract.dcContract.designId,
      'DC Artwork Title': contract.dcContract.title,
      'DC Artwork Size': contract.artSize + ' in',
      'DC Price Tier': contract.artSize + ' in',
      'DC Finished Envelope': contract.dcContract.finishedEnvelopeInches.width + ' x ' + contract.dcContract.finishedEnvelopeInches.height + ' in',
      'DC Installation Space': contract.physicalCanvas.width + ' x ' + contract.physicalCanvas.height + ' in',
      'DC Vinyl Color': contract.vinylColor,
      'DC Art Complexity': contract.complexityTier,
      'DC Text Labor': contract.textRows.length + ' @ $6.00',
      'Quantity': contract.quantity,
      'Size': contract.physicalCanvas.width + ' x ' + contract.physicalCanvas.height + ' in',
      'Width': contract.physicalCanvas.width + ' in',
      'Height': contract.physicalCanvas.height + ' in',
      'VINYL COLORS': contract.vinylColor,
      'Transfer Tape': 'Included',
      '_SRDDESIGNER': 'true',
      '_SRD Designer Build': 'v4.11-dc-personalize-draft',
      '_Template Key': 'blank_canvas',
      '_Blank Canvas Subfamily Key': 'die_cutting',
      '_Finished Size': contract.physicalCanvas.width + ' x ' + contract.physicalCanvas.height + ' in',
      '_Size': contract.physicalCanvas.width + ' x ' + contract.physicalCanvas.height + ' in',
      '_dcp_canvas_objects': JSON.stringify(contract.canvasObjects),
      '_dcp_physical_canvas': JSON.stringify(contract.physicalCanvas),
      '_dcp_die_production': JSON.stringify(contract.dieContract),
      '_dcp_dc_art_production': JSON.stringify(contract.dcContract),
      '_dcp_cart_edit_token': contract.token,
      '_dcp_pricing_group': contract.token,
      '_DCP Production Reference ID': contract.referenceId,
      '_DCP Final Proof Reference': contract.referenceId,
      '_DCP DC Art Catalog Version': CATALOG_VERSION,
      '_DCP DC Art Pricing Formula': 'trusted fixed-art base at certified artwork size plus text-object labor by finished-envelope height',
      '_DCP Pricing Model': 'DC Art Library exact-unit-price variants v1',
      '_DCP Unit Price Cents': contract.unitPriceCents,
      '_DCP Finished Price Cents': contract.finishedPriceCents,
      '_DCP Finished Quantity': contract.quantity,
      '_DCP Price Variant ID': contract.variantId,
      '_Matched Variant ID': contract.variantId,
      '_DCP Price Key': 'dc-art|' + contract.dcContract.designId + '|' + contract.artSize + '|' + contract.textRows.length + '|' + contract.variantId,
      '_DCP Surcharge Key': 'text|' + contract.textRows.length + '|600',
      '_DCP Text Object Count': contract.textRows.length,
      '_DCP Included Text Objects': 0,
      '_DCP Additional Text Objects': contract.textRows.length,
      '_DCP Additional Text Unit Cents': 600,
      '_DCP Additional Text Surcharge Cents': contract.textRows.length * 600,
      'Font': firstText.font,
      'Message': firstText.text,
      'Placement': contract.placement
    };
    Object.keys(properties).forEach(function (name) { hiddenProperty(form, name, properties[name]); });
    const proofReferenceField = root.querySelector('[data-srd-fixed-proof-reference-hidden]');
    if (proofReferenceField) proofReferenceField.value = contract.referenceId;
    root._srdDcInstalledContract = contract;
    return contract;
  }

  async function captureSimpleProof(root, contract) {
    const canvas = document.createElement('canvas');
    canvas.width = 1200;
    canvas.height = 1200;
    const context = canvas.getContext('2d');
    if (!context) throw new Error('The durable proof renderer is unavailable.');
    context.fillStyle = '#f7f7f3';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.strokeStyle = '#e35d13';
    context.lineWidth = 18;
    context.strokeRect(20, 20, 1160, 1160);
    context.fillStyle = '#111111';
    context.font = '700 34px sans-serif';
    context.fillText('SRD PERSONALIZATION PROOF', 70, 90);
    const source = root.querySelector('[data-srd-fixed-simple-proof-image]');
    if (source && source.currentSrc) {
      const response = await fetch(source.currentSrc, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('The trusted artwork proof image could not be loaded.');
      const objectUrl = URL.createObjectURL(await response.blob());
      try {
        const image = new Image();
        await new Promise(function (resolve, reject) { image.onload = resolve; image.onerror = reject; image.src = objectUrl; });
        context.drawImage(image, 250, 170, 700, 620);
      } finally {
        URL.revokeObjectURL(objectUrl);
      }
    }
    context.fillStyle = contract.vinylColor === 'White' ? '#222222' : contract.vinylColor;
    context.textAlign = 'center';
    context.font = '900 64px sans-serif';
    contract.textRows.forEach(function (row, index) { context.fillText(row.text, 600, 875 + index * 82, 1000); });
    context.fillStyle = '#333333';
    context.font = '600 27px sans-serif';
    context.fillText(contract.artSize + ' in · ' + contract.vinylColor + ' · ' + contract.placement, 600, 1100);
    const blob = await new Promise(function (resolve) { canvas.toBlob(resolve, 'image/png'); });
    if (!blob) throw new Error('The durable proof file could not be created.');
    return new File([blob], contract.referenceId + '.png', { type: 'image/png' });
  }

  function showError(root, message) {
    const local = root.querySelector('[data-srd-personalization-error], [data-srd-fixed-personalization-error]');
    const wrapper = root.querySelector('.product-form__error-message-wrapper');
    const target = local || (wrapper && wrapper.querySelector('.product-form__error-message'));
    if (target) target.textContent = message;
    if (local) local.hidden = false;
    if (wrapper) wrapper.hidden = false;
  }

  function prepareContractEvent(event, form, root) {
    if (!root || !propertyControl(root, ['Text 1'])) return false;
    try {
      installContract(root, form);
      return true;
    } catch (error) {
      event.preventDefault();
      event.stopImmediatePropagation();
      showError(root, error.message || 'The trusted DC personalization contract is incomplete.');
      return false;
    }
  }

  const submissionsInFlight = new WeakSet();

  function formProperty(form, name) {
    const field = Array.from(form.elements).find(function (element) {
      return element.name === 'properties[' + name + ']';
    });
    return field ? String(field.value || '') : '';
  }

  async function addAndVerifyContract(form, root, button) {
    if (submissionsInFlight.has(form)) return;
    submissionsInFlight.add(form);
    root.dataset.srdDcDirectAddState = 'starting';
    delete root.dataset.srdDcDirectAddError;
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    }
    let addedLine = null;
    try {
      const expectedVariant = String(form.querySelector('[name="id"]').value || '');
      const token = formProperty(form, '_dcp_cart_edit_token');
      const quantityField = root.querySelector('[name="quantity"]');
      const expectedQuantity = Number(quantityField && quantityField.value || 0);
      const expectedFinishedCents = Number(formProperty(form, '_DCP Finished Price Cents'));
      const protectedKeys = [
        'Product Family', '_Template Key', '_Blank Canvas Subfamily Key',
        '_dcp_canvas_objects', '_dcp_physical_canvas', '_dcp_die_production', '_dcp_dc_art_production',
        '_dcp_cart_edit_token', '_dcp_pricing_group', '_DCP Production Reference ID', '_DCP Final Proof Reference',
        '_DCP DC Art Catalog Version', '_DCP Pricing Model', '_DCP Unit Price Cents',
        '_DCP Finished Price Cents', '_DCP Finished Quantity', '_DCP Price Variant ID',
        '_DCP Price Key', '_DCP Surcharge Key', '_DCP Text Object Count',
        '_DCP Included Text Objects', '_DCP Additional Text Objects',
        '_DCP Additional Text Unit Cents', '_DCP Additional Text Surcharge Cents'
      ];
      if (!token || !expectedVariant || !Number.isInteger(expectedQuantity) || expectedQuantity < 1
          || !Number.isInteger(expectedFinishedCents) || expectedFinishedCents < 1) {
        throw new Error('The trusted DC cart identity or exact price is unresolved.');
      }
      const contract = root._srdDcInstalledContract;
      if (!contract || contract.variantId !== expectedVariant) throw new Error('The installed Custom Die contract is stale.');
      const formData = new FormData(form);
      const proofFile = await captureSimpleProof(root, contract);
      formData.set('properties[_DCP Final Proof File]', proofFile, proofFile.name);
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: formData
      });
      if (!addResponse.ok) {
        const failure = await addResponse.json().catch(function () { return {}; });
        throw new Error(failure.description || failure.message || 'Shopify rejected the trusted DC cart line.');
      }
      root.dataset.srdDcDirectAddState = 'added';
      const cartResponse = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error('Shopify cart readback is unavailable.');
      const cart = await cartResponse.json();
      const line = (cart.items || []).find(function (item) {
        return item.properties && String(item.properties._dcp_cart_edit_token || '') === token;
      });
      addedLine = line || null;
      if (!line) throw new Error('Shopify did not preserve the trusted DC transaction identity.');
      if (String(line.variant_id || line.id || '') !== expectedVariant
          || Number(line.quantity || 0) !== expectedQuantity
          || Number(line.final_line_price !== undefined ? line.final_line_price : line.line_price) !== expectedFinishedCents) {
        throw new Error('Shopify did not preserve the exact DC price-bearing variant, quantity, and cents.');
      }
      for (const key of protectedKeys) {
        if (String(line.properties && line.properties[key] || '') !== formProperty(form, key)) {
          throw new Error('Shopify did not preserve trusted DC property: ' + key + '.');
        }
      }
      const proofUrl = String(line.properties && line.properties['_DCP Final Proof File'] || '');
      if (!/^https:\/\/cdn\.shopify\.com\/s\/files\//.test(proofUrl)) {
        throw new Error('Shopify did not preserve the durable personalization proof file.');
      }
      root.dataset.srdDcDirectAddState = 'verified';
      const status = root.querySelector('[data-srd-fixed-personalization-status]');
      if (status) status.textContent = 'Personalized design added to cart. You can continue shopping or open your cart.';
      const panel = root.querySelector('[data-srd-fixed-personalize-panel]');
      if (panel) panel.setAttribute('data-srd-add-complete', 'true');
      document.dispatchEvent(new CustomEvent('srd:dc-personalize-added', { detail: { key: line.key, quantity: line.quantity } }));
    } catch (error) {
      if (addedLine && addedLine.key) {
        try {
          await fetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: addedLine.key, quantity: 0 })
          });
        } catch (rollbackError) {}
      }
      root.dataset.srdDcDirectAddState = 'error';
      root.dataset.srdDcDirectAddError = error.message || 'The trusted DC cart line could not be verified.';
      showError(root, error.message || 'The trusted DC cart line could not be verified.');
      if (button) {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      }
    } finally {
      submissionsInFlight.delete(form);
    }
  }

  document.addEventListener('click', async function (event) {
    const button = event.target.closest && event.target.closest('button[data-srd-fixed-submit]');
    if (!button) return;
    const root = button.closest('[data-srd-fixed-die-cut]');
    const form = button.closest('form');
    if (!form || !root || !propertyControl(root, ['Text 1'])) return;
    root.dataset.srdDcClickHook = 'true';
    event.preventDefault();
    event.stopImmediatePropagation();
    if (prepareContractEvent(event, form, root)) await addAndVerifyContract(form, root, button);
  }, true);

  document.addEventListener('submit', async function (event) {
    const form = event.target;
    const root = form && form.closest && form.closest('[data-srd-fixed-die-cut]');
    if (!root || !propertyControl(root, ['Text 1'])) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (prepareContractEvent(event, form, root)) {
      await addAndVerifyContract(form, root, root.querySelector('button[data-srd-fixed-submit]'));
    }
  }, true);

  function bindContractRoot(root) {
    if (!root || root.dataset.srdDcDirectBound === 'true') return;
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const button = root.querySelector('button[data-srd-fixed-submit]');
    if (!form || !button) return;
    root.dataset.srdDcDirectBound = 'true';
    button.addEventListener('click', async function (event) {
      if (!propertyControl(root, ['Text 1'])) return;
      root.dataset.srdDcClickHook = 'true';
      event.preventDefault();
      event.stopImmediatePropagation();
      if (prepareContractEvent(event, form, root)) await addAndVerifyContract(form, root, button);
    }, true);
    form.addEventListener('submit', async function (event) {
      if (!propertyControl(root, ['Text 1'])) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (prepareContractEvent(event, form, root)) await addAndVerifyContract(form, root, button);
    }, true);
  }

  function bindContractRoots() {
    document.querySelectorAll('[data-srd-fixed-die-cut]').forEach(bindContractRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindContractRoots, { once: true });
  else bindContractRoots();

  document.addEventListener('shopify:section:load', function (event) {
    bindContractRoot(event.target.querySelector('[data-srd-fixed-die-cut]'));
  });

  window.SRDDcPersonalizeContract = Object.freeze({
    version: 'v4.11-draft-2',
    install: function (root, form) { installContract(root, form); }
  });
}());
